import { CandidateEndpoints, RequestMethods, useRequest } from '@shared/index';
import type { CommonResponse, RequestDeps } from '@shared/types';

import type { CandidateAuth } from '../../model/types';

export interface NewCandidateRequestParams {
  refMagCode?: string;
  refDeptCode?: string;
  refDeptId?: string;
  refBranchId?: string;
  newCandidate: Omit<CandidateAuth, 'password'>;
}

export const useNewCandidate = (
  request: NewCandidateRequestParams,
  deps: RequestDeps
) => {
  const isAutoFetch =
    !!request.newCandidate.nickname && !!request.newCandidate.phone;

  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    NewCandidateRequestParams,
    CommonResponse,
    CommonResponse
  >({
    params: {
      key: 'newCandidate',
      method: RequestMethods.POST,
      url: `${CandidateEndpoints.CANDIDATES}/new`,
      request,
      fetchManual: !isAutoFetch,
      deps,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
